import { useActivityMatches } from "PFApp/activities/show/hooks/use_activity_matches";
import { useMatchesActions, useMatchesStore } from "PFApp/activities/show/store/matches";
import Table from "PFComponents/table";
import { Tile } from "PFComponents/tile";

import { MatchTableEntry } from "../../../activity_tabs.utils";
import { useMatchesShortlistTableColumns } from "../../../hooks/use_matches_shortlist_table_columns";

type MatchesCardsViewProps = {
  matchesEntries: MatchTableEntry[];
  isLoading: boolean;
};

export const MatchesTableView = ({ matchesEntries, isLoading }: MatchesCardsViewProps) => {
  const { matchesMeta } = useActivityMatches();
  const matchesParams = useMatchesStore((state) => state.matchesParams);
  const { updateMatchesParams } = useMatchesActions();

  const { generateColumns } = useMatchesShortlistTableColumns<MatchTableEntry>({
    isShortlistTabActive: false
  });

  return (
    <Tile variant="light" paddingVariant="lg" qaId="ActivityMatchesTabTableContainer">
      <Table<MatchTableEntry>
        isLoading={isLoading}
        tableData={matchesEntries}
        generateColumns={generateColumns}
        paginationOptions={{
          currentPage: matchesParams.page || 1,
          onClick: (page) => updateMatchesParams({ page }),
          totalPages: matchesMeta.totalPages
        }}
        compact
      />
    </Tile>
  );
};
